import siteMap, { SitePage, SitePageType } from '../../Model/siteMap';

export function filterPagesByType(filter: SitePageType | null): SitePage[] {
    if (!filter) return siteMap.pages;
    return siteMap.pages.filter((p) => p.type === filter);
}

/** First path segment after /, or null for home. */
export function pageIdFromPathname(pathname: string): string | null {
    const trimmed = pathname.replace(/\/+$/, '') || '/';
    if (trimmed === '/' || trimmed === '') return null;
    const first = trimmed.replace(/^\//, '').split('/')[0];
    return first || null;
}

export function findPageById(id: string): SitePage | undefined {
    return siteMap.pages.find((p) => p.id === id);
}

export function parseTypeFromSearch(search: string): SitePageType | null {
    const q = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search);
    const t = q.get('type');
    if (!t) return null;
    return (Object.values(SitePageType) as string[]).includes(t) ? (t as SitePageType) : null;
}

export function buildListSearch(filter: SitePageType | null): string {
    if (!filter) return '';
    return `?type=${filter}`;
}

/** Reserved first path segment; not a site map page id. */
export const RESUME_PATH_ID = 'resume';

/** Reserved first path segment; not a site map page id. */
export const LINKS_PATH_ID = 'links';

export interface ParsedLocation {
    pageId: string | null;
    page: SitePage | null;
    filter: SitePageType | null;
    unknownPageId: boolean;
    showResume: boolean;
    showLinks: boolean;
}

export function parseContentLocation(pathname: string, search: string): ParsedLocation {
    const pageId = pageIdFromPathname(pathname);
    if (pageId === RESUME_PATH_ID) {
        return {
            pageId,
            page: null,
            filter: null,
            unknownPageId: false,
            showResume: true,
            showLinks: false,
        };
    }
    if (pageId === LINKS_PATH_ID) {
        return {
            pageId,
            page: null,
            filter: null,
            unknownPageId: false,
            showResume: false,
            showLinks: true,
        };
    }
    const page = pageId ? findPageById(pageId) : undefined;
    const unknownPageId = Boolean(pageId && !page);
    return {
        pageId,
        page: page ?? null,
        filter: parseTypeFromSearch(search),
        unknownPageId,
        showResume: false,
        showLinks: false,
    };
}

export function readRouteFromWindow(): ParsedLocation & { pages: SitePage[] } {
    const { pathname, search } = window.location;
    const parsed = parseContentLocation(pathname, search);
    if (parsed.unknownPageId) {
        return {
            pageId: null,
            page: null,
            filter: parsed.filter,
            unknownPageId: true,
            showResume: false,
            showLinks: false,
            pages: filterPagesByType(parsed.filter),
        };
    }
    if (parsed.showResume) {
        return {
            ...parsed,
            pages: [],
        };
    }
    if (parsed.showLinks) {
        return {
            ...parsed,
            pages: [],
        };
    }
    return {
        ...parsed,
        pages: filterPagesByType(parsed.filter),
    };
}
